/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */


AddModel({
	Name: "SteelYoke",
	Folder: "Yoke",
	Parent: "Yoke",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Metal", "Yokes"],
	AddPose: ["Yokes"],
	Layers: ToLayerMap([
		{ Name: "Steel", Layer: "Yoke", Pri: 10,
			Invariant: true,
			HideWhenOverridden: true,
			DisplacementSprite: "Yoke",
			DisplaceLayers: ToMap(["Yoke"]),
			DisplaceAmount: 40,
		},
		{ Name: "SteelBar", Layer: "Yoke", Pri: 10.1,
			Invariant: true,
			HideWhenOverridden: true,
			NoOverride: true,
		},
	])
});
AddModel({
	Name: "SteelSpreader",
	Folder: "Spreader",
	Parent: "Spreader",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Metal", "Spreaders"],
	AddPose: ["Spreader", "WideSpread"],
	Layers: ToLayerMap([
		{ Name: "ShortLeft", Layer: "AnkleLeftOver", Pri: 10,
			Poses: ToMap([...LEGPOSES]),
			HideWhenOverridden: true,
			
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			DisplacementSprite: "AnkleCuffLeft",
			DisplaceLayers: ToMap(["LegCuffs"]),
			DisplaceAmount: 50,
		},
		{ Name: "ShortRight", Layer: "AnkleRightOver", Pri: 10,
			Invariant: true,
			Poses: ToMap(["Spread"]),
			HideWhenOverridden: true,
			DisplacementSprite: "AnkleCuffRight",
			DisplaceLayers: ToMap(["LegCuffs"]),
			DisplaceAmount: 50,
		},
		{ Name: "Bar", Layer: "SpreaderBar", Pri: 10,
			Invariant: true,
			Poses: ToMap(["Spread"]),
			HideWhenOverridden: true,
		},
	])
});

AddModel({
	Name: "HeavyYoke",
	Folder: "Yoke",
	Parent: "Yoke",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Metal", "Yokes"],
	AddPose: ["Yokes"],
	Layers: ToLayerMap([
		{ Name: "HeavySteel", Layer: "Yoke", Pri: 35,
			Invariant: true,
			HideWhenOverridden: true,
			DisplacementSprite: "Yoke",
			DisplaceLayers: ToMap(["Yoke"]),
			DisplaceAmount: 40,
			InheritColor: "BaseMetal",
		},
		{ Name: "HeavySteelPins", Layer: "Yoke", Pri: 35.2,
			Invariant: true,
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "HeavySteel",
			InheritColor: "Pins",
			LockLayer: true,
		},
		{ Name: "HeavySteelLock", Layer: "Yoke", Pri: 35.2,
			Invariant: true,
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "HeavySteel",
			InheritColor: "Locks",
			LockLayer: true,
		},
		{ Name: "HeavySteelHardware", Layer: "Yoke", Pri: 35.1,
			Invariant: true,
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "HeavySteel",
			InheritColor: "Shackles",
			LockLayer: true,
		},
	])
});

AddModel({
	Name: "HeavyFiddle",
	Folder: "Fiddle",
	Parent: "Fiddle",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Metal", "Fiddles"],
	AddPose: ["Fiddles"],
	Layers: ToLayerMap([
		{ Name: "FiddleLines", Layer: "FiddleFront", Pri: 5.1,
			Invariant: true,
			HideWhenOverridden: true,
			NoColorize: true,
			DisplacementSprite: "Fiddle",
			DisplacementInvariant: true,
			DisplaceLayers: ToMap(["Fiddle"]),
			DisplaceAmount: 25,
		},
		{ Name: "FiddleBody", Layer: "FiddleFront", Pri: 5,
			Invariant: true,
			TieToLayer: "FiddleLines",
			InheritColor: "BaseMetal",
		},
		{ Name: "FiddleLock", Layer: "FiddleFront", Pri: 5,
			Invariant: true,
			TieToLayer: "FiddleLines",
			InheritColor: "Lock",
		},
		{ Name: "BackFiddleLines", Layer: "Yoke", Pri: 5.1,
			Invariant: true,
			HideWhenOverridden: true,
			NoColorize: true,
		},
		{ Name: "BackFiddleBody", Layer: "Yoke", Pri: 5,
			Invariant: true,
			TieToLayer: "BackFiddleLines",
			InheritColor: "BaseMetal",
		},
	])
});
